// extracted by mini-css-extract-plugin
export var backdropBlur = "_d8-0";
export var contentCard = "_d8-5";
export var frame = "_d8-2";
export var image = "_d8-4";
export var imagePane = "_d8-3";
export var modal = "_d8-1";